import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Organization } from '../models/organization.model';
import { GenericApiService } from './generic-api.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private api = inject(GenericApiService);

  getOrganizations(): Observable<Organization[]> {
    return this.api.query<Organization[]>('LIST_ORGANIZATIONS');
  }

  createOrganization(name: string): Observable<Organization> {
    return this.api.query<Organization>('CREATE_ORGANIZATION', { name });
  }

  getOrganizationUsers(orgId: string): Observable<any[]> {
    return this.api.query<any[]>('LIST_ORGANIZATION_USERS', { orgId });
  }

  addOrganizationUser(orgId: string, email: string, role: string): Observable<any> {
    return this.api.query<any>('ADD_ORGANIZATION_USER', { orgId, email, role });
  }

  removeOrganizationUser(orgId: string, uid: string): Observable<any> {
    return this.api.query<any>('REMOVE_ORGANIZATION_USER', { orgId, uid });
  }

  updateOrganizationUserRole(orgId: string, uid: string, role: string): Observable<any> {
    return this.api.query<any>('UPDATE_ORGANIZATION_USER_ROLE', { orgId, uid, role });
  }
}
